<div
  class="content"
  [class.hide-content]="showHowdyVideo"
>
  <ng-template #formContainer>
    <div class="login-container" [class.mobile]="isMobile">
        <div class="logo-container">
          <img [src]="companyLogo" (error)="getHowdyLogo()" class="logo" alt="logo">
            <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
        </div>

        <div class="text-container">
          <ng-content></ng-content>
        </div>

        <div class="anonymous-container" (click)="openAnswersAnonymousDialog()">
          <div class="box">
            <img class="lock" [src]="s3BaseUrl + 'assets/images/Lock.png'" alt="lock">
            <p class="text">{{ 'WebApp.v1.Shared.Anonymous' | translate }}</p>
          </div>
        </div>
      </div>
  </ng-template>

  <app-video-background
    class="survey-video"
    source="water"
    background="linear-gradient(180deg, rgba(0, 0, 0, 0) 75%, rgba(0, 0, 0, 1) 100%),
    linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%),
    linear-gradient(0deg, rgba(1, 21, 30, 0.90) 34.64%, rgba(1, 21, 30, 0.00) 76.38%)"
    [showAnonymous]="false"
    [showLogo]="false"
  >
    <div class="overlay waves"></div>

    @if (isMobile) {
      <ng-container *ngTemplateOutlet="formContainer"></ng-container>
    }

    <div class="right-side">
      <div class="title-container motto">
        <h1 class="title">{{ 'WebApp.v1.Auth.Login.HeadLine' | translate }}</h1>

        <div class="why">
          <div class="read-why" (click)="scrollToWhy()">{{ 'WebApp.v1.Auth.Login.Read.Why' | translate }}</div>
          <span class="white-slash">/</span>
          <div class="play-why" (click)="showHowdyVideo = true"><i class="fa-solid fa-play"></i></div>
        </div>
      </div>

      @if (!isMobile) {
        <div class="arrow-container" (click)="scrollToWhy()">
          <img [src]="s3BaseUrl + 'assets/images/ChevronDownFaded.png'" class="image" alt="arrow">
        </div>
      }
    </div>
  </app-video-background>

  <div #imageContainer class="image-container" id="image-container">
    <div class="overlay sunset"></div>
    <div class="right-side reasons">
      <div class="title-container reasons">
        @for (reason of [1, 2, 3]; track $index) {
          <div class="reason">
            <div class="checkmark-circle">
              <i class="fa-solid fa-check"></i>
            </div>
            <p class="text">{{ 'WebApp.v1.Auth.Login.Reasons.Reason' + ($index + 1) | translate }}</p>
          </div>
        }
      </div>

      <div class="login-container-action-footer">
        <div class="login-container-action-footer-link">
          <a href="https://howdy.care" target="_blank">{{ 'WebApp.v1.Auth.Login.WhatIsHowdy' | translate }}</a>
        </div>
        <div class="login-container-action-footer-link">
          <a href="https://howdy.care/legal/privacy-policy-v3-0-b2b/" target="_blank">{{ 'WebApp.v1.Auth.Login.TermsAndConditions' | translate }}</a>
        </div>
      </div>
    </div>
    <img class="image" [src]="s3BaseUrl + 'assets/images/man_on_rock.png'" alt="man">
  </div>

  @if (!isMobile) {
    <ng-container *ngTemplateOutlet="formContainer"></ng-container>
  }
</div>

@if (showHowdyVideo) {
  <div class="video-container howdy-video" [class.hide-content]="!showHowdyVideo">
    <i class="fa-solid fa-xmark close-button" (click)="showHowdyVideo = false"></i>
    <video class="video" controls autoplay>
      <source [src]="s3BaseUrl + 'assets/videos/Howdy Wellbeing Intro ' + language + videoFormat" type="video/mp4">
    </video>
  </div>
}
